import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SettingsProvider } from "@/context/ShopContext";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { TableBanner } from "@/components/TableBanner";
import { TabBar } from "@/components/TabBar";
import MenuPage from "@/pages/MenuPage";
import ProductPage from "@/pages/ProductPage";
import BuilderPage from "@/pages/BuilderPage";
import Cart from "@/pages/Cart";
import Profile from "@/pages/Profile";
import OrderStatus from "@/pages/OrderStatus";
import MyOrders from "@/pages/MyOrders";
import FeedbackPage from "@/pages/FeedbackPage";
import AccountPage from "@/pages/AccountPage";
import LegalPage from "@/pages/LegalPage";
import AssistantPage from "@/pages/AssistantPage";
import ChangeRequestPage from "@/pages/ChangeRequestPage";
import QrPage from "@/pages/QrPage";

export default function App() {
  return (
    <BrowserRouter>
      <SettingsProvider>
        <AuthProvider>
          <CartProvider>
            <Toaster position="top-center" richColors />
            <div className="max-w-[640px] mx-auto min-h-screen flex flex-col sm:border-x" style={{ background: "var(--surface)", borderColor: "var(--border-c)" }}>
              <TableBanner />
              <main className="flex-1 flex flex-col">
                <Routes>
                  <Route path="/" element={<MenuPage />} />
                  <Route path="/menu" element={<Navigate to="/" replace />} />
                  <Route path="/product/:id" element={<ProductPage />} />
                  <Route path="/builder" element={<BuilderPage />} />
                  <Route path="/carrello" element={<Cart />} />
                  <Route path="/profilo" element={<Profile />} />
                  <Route path="/ordini" element={<MyOrders />} />
                  <Route path="/order/:id" element={<OrderStatus />} />
                  <Route path="/order/:id/modifica" element={<ChangeRequestPage />} />
                  <Route path="/account" element={<AccountPage />} />
                  <Route path="/legal/:doc" element={<LegalPage />} />
                  <Route path="/assistente" element={<AssistantPage />} />
                  <Route path="/feedback/:orderId" element={<FeedbackPage />} />
                  <Route path="/qr" element={<QrPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </main>
              <TabBar />
            </div>
          </CartProvider>
        </AuthProvider>
      </SettingsProvider>
    </BrowserRouter>
  );
}
